/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type HomePickupMenuQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  costChannel?: Types.InputMaybe<Types.CostChannel>;
}>;

export type HomePickupMenuQuery = {
  readonly __typename?: 'Query';
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly deliveryFee: number;
    readonly showDeliveryFeeDisclosure: boolean;
    readonly menu: {
      readonly __typename: 'Menu';
      readonly id: string;
      readonly categories: ReadonlyArray<{
        readonly __typename: 'MenuCategory';
        readonly id: string;
        readonly products: ReadonlyArray<{
          readonly __typename: 'Product';
          readonly id: string;
          readonly slug: string;
          readonly isModifiable: boolean;
          readonly name: string;
          readonly description: string;
          readonly cost: number;
          readonly baseProduct: {
            readonly __typename: 'BaseProduct';
            readonly id: string;
            readonly slug: string;
            readonly lineageKey: string | null;
            readonly calories: number | null;
            readonly totalFatG: number | null;
            readonly totalCarbsG: number | null;
            readonly dietaryFiberG: number | null;
            readonly sugarsG: number | null;
            readonly proteinG: number | null;
          };
          readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
          readonly allergenProperties: ReadonlyArray<{
            readonly __typename: 'AllergenProperty';
            readonly id: string;
            readonly name: Types.AllergenPropertyKind;
          }>;
        }>;
      }>;
    };
  } | null;
};

export type HomeDeliveryMenuQueryVariables = Types.Exact<{
  input: Types.LocationByAddressInput;
  costChannel?: Types.InputMaybe<Types.CostChannel>;
}>;

export type HomeDeliveryMenuQuery = {
  readonly __typename?: 'Query';
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly deliveryFee: number;
          readonly showDeliveryFeeDisclosure: boolean;
          readonly menu: {
            readonly __typename: 'Menu';
            readonly id: string;
            readonly categories: ReadonlyArray<{
              readonly __typename: 'MenuCategory';
              readonly id: string;
              readonly products: ReadonlyArray<{
                readonly __typename: 'Product';
                readonly id: string;
                readonly slug: string;
                readonly isModifiable: boolean;
                readonly name: string;
                readonly description: string;
                readonly cost: number;
                readonly baseProduct: {
                  readonly __typename: 'BaseProduct';
                  readonly id: string;
                  readonly slug: string;
                  readonly lineageKey: string | null;
                  readonly calories: number | null;
                  readonly totalFatG: number | null;
                  readonly totalCarbsG: number | null;
                  readonly dietaryFiberG: number | null;
                  readonly sugarsG: number | null;
                  readonly proteinG: number | null;
                };
                readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
                readonly allergenProperties: ReadonlyArray<{
                  readonly __typename: 'AllergenProperty';
                  readonly id: string;
                  readonly name: Types.AllergenPropertyKind;
                }>;
              }>;
            }>;
          };
        };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export type HomeMenuFragment = {
  readonly __typename: 'Restaurant';
  readonly id: string;
  readonly deliveryFee: number;
  readonly showDeliveryFeeDisclosure: boolean;
  readonly menu: {
    readonly __typename: 'Menu';
    readonly id: string;
    readonly categories: ReadonlyArray<{
      readonly __typename: 'MenuCategory';
      readonly id: string;
      readonly products: ReadonlyArray<{
        readonly __typename: 'Product';
        readonly id: string;
        readonly slug: string;
        readonly isModifiable: boolean;
        readonly name: string;
        readonly description: string;
        readonly cost: number;
        readonly baseProduct: {
          readonly __typename: 'BaseProduct';
          readonly id: string;
          readonly slug: string;
          readonly lineageKey: string | null;
          readonly calories: number | null;
          readonly totalFatG: number | null;
          readonly totalCarbsG: number | null;
          readonly dietaryFiberG: number | null;
          readonly sugarsG: number | null;
          readonly proteinG: number | null;
        };
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
        readonly allergenProperties: ReadonlyArray<{
          readonly __typename: 'AllergenProperty';
          readonly id: string;
          readonly name: Types.AllergenPropertyKind;
        }>;
      }>;
    }>;
  };
};

export const HomeMenuFragmentDoc = gql`
  fragment HomeMenu on Restaurant {
    id
    __typename
    deliveryFee
    showDeliveryFeeDisclosure
    menu {
      id
      __typename
      categories {
        id
        __typename
        products {
          id
          __typename
          slug
          isModifiable
          baseProduct {
            __typename
            id
            slug
            lineageKey
            calories
            totalFatG
            totalCarbsG
            dietaryFiberG
            sugarsG
            proteinG
          }
          asset {
            url
          }
          name
          description
          cost: channelCost(costChannel: $costChannel)
          allergenProperties {
            id
            __typename
            name
          }
        }
      }
    }
  }
`;
export const HomePickupMenuDocument = gql`
  query HomePickupMenu($id: ID!, $costChannel: CostChannel) {
    restaurant(id: $id) {
      ...HomeMenu
    }
  }
  ${HomeMenuFragmentDoc}
`;

export function useHomePickupMenuQuery(
  options: Omit<Urql.UseQueryArgs<HomePickupMenuQueryVariables>, 'query'>,
) {
  return Urql.useQuery<HomePickupMenuQuery, HomePickupMenuQueryVariables>({
    query: HomePickupMenuDocument,
    ...options,
  });
}
export const HomeDeliveryMenuDocument = gql`
  query HomeDeliveryMenu($input: LocationByAddressInput!, $costChannel: CostChannel) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        restaurant {
          ...HomeMenu
        }
      }
    }
  }
  ${HomeMenuFragmentDoc}
`;

export function useHomeDeliveryMenuQuery(
  options: Omit<Urql.UseQueryArgs<HomeDeliveryMenuQueryVariables>, 'query'>,
) {
  return Urql.useQuery<HomeDeliveryMenuQuery, HomeDeliveryMenuQueryVariables>({
    query: HomeDeliveryMenuDocument,
    ...options,
  });
}
